module.exports = __webpack_public_path__ + "static/media/king-must-dine.db12df14.png";